import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=e82c8032&"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports